export default interface ILocalSettingsState {
  alarmSound: string;
  volume: number;
}

export const DEFAULT_STATE: ILocalSettingsState = {
  alarmSound: 'bell.mp3',
  volume: 50,
};



// WEBPACK FOOTER //
// ./src/redux/modules/localSettings/state.ts